/**
 * Vehicle Insurance Claiming Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { InsuranceClaimHistoryListItemDto } from '../model/insuranceClaimHistoryListItemDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InsuranceClaimingHistoryViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/InsuranceClaimingHistoryView/branch/{branchId}/history AmsResource:{country}/{business}/_* 
     * @param branchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoryByBranch(branchId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InsuranceClaimHistoryListItemDto>>;
    public getHistoryByBranch(branchId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByBranch(branchId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByBranch(branchId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (branchId === null || branchId === undefined) {
            throw new Error('Required parameter branchId was null or undefined when calling getHistoryByBranch.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<InsuranceClaimHistoryListItemDto>>(`${this.basePath}/api/InsuranceClaimingHistoryView/branch/${encodeURIComponent(String(branchId))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/InsuranceClaimingHistoryView/business/{businessId}/history AmsResource:{country}/{business}/_* 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoryByBusiness(businessId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InsuranceClaimHistoryListItemDto>>;
    public getHistoryByBusiness(businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByBusiness(businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByBusiness(businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getHistoryByBusiness.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<InsuranceClaimHistoryListItemDto>>(`${this.basePath}/api/InsuranceClaimingHistoryView/business/${encodeURIComponent(String(businessId))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingHistoryView/country/{countryId}/history AmsResource:{countryId} 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoryByCountry(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InsuranceClaimHistoryListItemDto>>;
    public getHistoryByCountry(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByCountry(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InsuranceClaimHistoryListItemDto>>>;
    public getHistoryByCountry(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getHistoryByCountry.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<InsuranceClaimHistoryListItemDto>>(`${this.basePath}/api/InsuranceClaimingHistoryView/country/${encodeURIComponent(String(countryId))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
